import type { LearningLanguage, VerbsData } from '../types';
import { t } from '../i18n/translations';
import type { Language } from '../i18n/translations';
import { getVerbDeckOptions } from '../utils/verbPractice';

interface SwipeToolbarProps {
  deck: string;
  wordLang: 'pl' | 'ru';
  hideTables: boolean;
  hideTranslation: boolean;
  randomMode: boolean;
  showKonj: boolean;
  isAllDeck: boolean;
  onDeckChange: (deck: string) => void;
  onWordLangChange: (lang: 'pl' | 'ru') => void;
  onHideTablesChange: (hide: boolean) => void;
  onHideTranslationChange: (hide: boolean) => void;
  onRandomModeChange: (random: boolean) => void;
  onShowKonjChange: (show: boolean) => void;
  learningLanguage?: LearningLanguage;
  verbsData?: VerbsData;
  language?: Language;
}

export default function SwipeToolbar({
  deck,
  wordLang,
  hideTables,
  hideTranslation,
  randomMode,
  showKonj,
  isAllDeck,
  onDeckChange,
  onWordLangChange,
  onHideTablesChange,
  onHideTranslationChange,
  onRandomModeChange,
  onShowKonjChange,
  learningLanguage = 'pl',
  verbsData = {},
  language = 'en',
}: SwipeToolbarProps) {
  const deckOptions = getVerbDeckOptions(verbsData, learningLanguage);
  const sourceLanguageLabel = t(
    language,
    learningLanguage === 'lt' ? 'learningLanguage.lithuanian' : 'learningLanguage.polish',
  );

  return (
    <div className="toolbar">
      <div className="group">
        <label className="inline">
          {t(language, 'kon.conjugation')}
          <select value={deck} onChange={(e) => onDeckChange(e.target.value)}>
            {deckOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
        <label className="inline">
          {t(language, 'kon.word')}
          <select
            value={wordLang}
            onChange={(e) => onWordLangChange(e.target.value as 'pl' | 'ru')}
          >
            <option value="pl">{sourceLanguageLabel}</option>
            <option value="ru">{t(language, 'kon.optRussian')}</option>
          </select>
        </label>
      </div>
      <div className="group checkboxes">
        <label className="inline">
          <input
            type="checkbox"
            checked={hideTables}
            onChange={(e) => onHideTablesChange(e.target.checked)}
          />
          {t(language, 'kon.hideTables')}
        </label>
        <label className="inline">
          <input
            type="checkbox"
            checked={hideTranslation}
            onChange={(e) => onHideTranslationChange(e.target.checked)}
          />
          {t(language, 'kon.hideTranslation')}
        </label>
        <label className="inline">
          <input
            type="checkbox"
            checked={randomMode}
            onChange={(e) => onRandomModeChange(e.target.checked)}
          />
          {t(language, 'kon.randomCard')}
        </label>
        {isAllDeck && (
          <label className="inline">
            <input
              type="checkbox"
              checked={showKonj}
              onChange={(e) => onShowKonjChange(e.target.checked)}
            />
            {t(language, 'kon.showK')}
          </label>
        )}
      </div>
    </div>
  );
}
